export function pathWithoutLeadingSlash(url: string) {
  return url.replace(/^\//, '')
}

export function pathWithLeadingSlash(url: string) {
  return `/${pathWithoutLeadingSlash(url)}`
}

export function pathWithoutTrailingSlash(url: string) {
  return url.replace(/\/$/, '')
}

export function pathWithTrailingSlash(url: string) {
  return `${pathWithoutTrailingSlash(url)}/`
}
